const updateSelectedMuxVideoUrl = (state, { payload: { url } }) => {
	state.selectedMuxVideoUrl = url;
};

export default updateSelectedMuxVideoUrl;
